import React from 'react'

export default function List() {
  return (
    <div>
      <h1 className="text-2xl mb-3">Hello Savings Summaries</h1>
      <a href="/savings_summaries/new"
         className="mt-3 rounded-full bg-indigo-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
      >
        New Savings Summary
      </a>
    </div>
  )
}
